export default "__VITE_ASSET__B8fHf6Bf__"